import { axios } from '@/libs/api.request';
import { Response } from '@/types/request.d';

interface promoteDetailParams {
    project_id: string;
}

export interface promoteDetailRes {
  balance: string;
  user_count: string;
  code: string;
  url: string;
  check: string;
}

interface flowListParams {
  page: number;
  page_size: number;
}

export interface flowListItem {
  type: string;
  balance: string;
  content: string;
  created_time: string;
  project_name: string;
  package_fee: string;
  status_code: string;
  comment: string;
}

interface flowListDes {
  list: flowListItem[];
  page_size: number;
  total: number;
  page: number;
}

interface applyParams {
    money: string;
    type: string;
    account: string;
    name: string;
}

/**
 * 获取合作推广详情
 */
export const getDetail = (params: promoteDetailParams) => axios.request<Response<any>>({
    url: '/sys/user/promote/get-detail',
    method: 'get',
    params,
    // mock: true,
});

/**
 * 流水明细
 */
export const getDetailList = (params: flowListParams) => axios.request<Response<any>>({
    url: '/sys/user/promote/get-detail-list',
    method: 'get',
    params,
    // mock: true,
});

/**
 * 申请提现
 */
export const postApply = (params: applyParams) => axios.request({
    url: '/sys/user/promote/apply',
    method: 'post',
    data: params,
    customTips: true,
    // mock: true,
});

/**
 * 流水明细
 */
export const getSecret = () => axios.request<Response<{
  user_id: string;
  product_id: string;
  secret: string;
}>>({
    url: '/sys/user/promote/get-secret',
    method: 'get',
    // mock: true,
});
